import React from 'react';

function NotFoundPostsIcon() {
    return (
        <svg className="icon not-found-posts" viewBox="0 0 253 140">
            <defs>
                <filter id="a" width="105%" height="110.5%" x="-2.5%" y="-3.3%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        values="0 0 0 0 0.839215686 0 0 0 0 0.831372549 0 0 0 0 0.831372549 0 0 0 1 0"
                    />
                </filter>
                <filter id="c" width="104.6%" height="110.5%" x="-2.3%" y="-3.3%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
                    <feColorMatrix
                        in="shadowBlurOuter1"
                        values="0 0 0 0 0.839215686 0 0 0 0 0.831372549 0 0 0 0 0.831372549 0 0 0 1 0"
                    />
                </filter>
                <rect id="b" width="220" height="105" x="0" y="0" rx="10" />
                <rect id="d" width="240" height="105" x="0" y="0" rx="10" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g transform="translate(13 10)">
                    <use xlinkHref="#b" fill="#000" filter="url(#a)" />
                    <use xlinkHref="#b" fill="#EDEDED" />
                    <g transform="translate(8 53)">
                        <path fill="#F3F3F3" stroke="#D8D8D8" d="M.5.5h203v25H.5z" />
                        <rect width="80" height="10" x="8" y="8" fill="#000" fillOpacity=".1" rx="5" />
                        <rect width="15" height="10" x="158" y="8" fill="#D8D8D8" rx="5" />
                        <rect width="15" height="10" x="181" y="8" fill="#D8D8D8" rx="5" />
                    </g>
                    <rect width="24" height="10" x="8" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="16" height="10" x="172" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="24" height="10" x="40" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="16" height="10" x="196" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="30" height="10" x="23" y="8" fill="#E0E0E0" rx="5" />
                    <path fill="#D8D8D8" d="M8 26h204v1H8z" />
                    <rect width="10" height="10" x="8.003" y="8" fill="#E0E0E0" rx="5" />
                    <rect width="10" height="10" x="8.003" y="35" fill="#D8D8D8" rx="5" />
                    <rect width="120" height="10" x="23" y="35" fill="#D8D8D8" rx="5" />
                </g>
                <g transform="translate(3 30)">
                    <use xlinkHref="#d" fill="#000" filter="url(#c)" />
                    <use xlinkHref="#d" fill="#E5E5E5" />
                    <g transform="translate(8 53)">
                        <path fill="#F3F3F3" stroke="#D8D8D8" d="M.5.5h223v25H.5z" />
                        <rect width="80" height="10" x="8" y="8" fill="#000" fillOpacity=".1" rx="5" />
                        <rect width="15" height="10" x="178" y="8" fill="#D8D8D8" rx="5" />
                        <rect width="15" height="10" x="201" y="8" fill="#D8D8D8" rx="5" />
                    </g>
                    <rect width="24" height="10" x="8" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="16" height="10" x="192" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="24" height="10" x="40" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="16" height="10" x="216" y="87" fill="#D8D8D8" rx="5" />
                    <rect width="30" height="10" x="23" y="8" fill="#D8D8D8" rx="5" />
                    <path fill="#D8D8D8" d="M8 26h224v1H8z" />
                    <rect width="10" height="10" x="8.003" y="8" fill="#D8D8D8" rx="5" />
                    <rect width="10" height="10" x="8.003" y="35" fill="#CCC" rx="5" />
                    <rect width="120" height="10" x="23" y="35" fill="#CCC" rx="5" />
                </g>
                <g transform="translate(213)">
                    <circle cx="20" cy="20" r="20" fill="#F6F6F6" />
                    <path
                        fill="gray"
                        d="M20 5c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15zm6.42 8.58a1.125 1.125 0 0 0-1.59 0L20 18.409l-4.83-4.83-.126-.108a1.125 1.125 0 0 0-1.464 1.7L18.409 20l-4.83 4.83-.108.126a1.125 1.125 0 0 0 1.7 1.464L20 21.591l4.83 4.83.126.108a1.125 1.125 0 0 0 1.464-1.7L21.591 20l4.83-4.83.108-.126c.327-.44.29-1.065-.109-1.464z"
                    />
                </g>
            </g>
        </svg>
    );
}

export default NotFoundPostsIcon;
